import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import styles from './ButtonWithLoader.module.scss';
import SvgIcon from 'components/SvgIcon/SvgIcon';

const ButtonWithLoader = ({
  bsStyle = 'primary',
  bsSize,
  disabled = false,
  href = '',
  loading = false,
  onClick = null,
  style = null,
  className = '',
  text = '',
  success = false,
  id = '',
}) => {
  return (
    <>
      <Button
        bsStyle={success ? 'success' : bsStyle}
        {...(bsSize && { bsSize })}
        disabled={disabled}
        href={href}
        onClick={onClick}
        style={style}
        className={className + ' ' + styles.button}
        id={id}
      >
        {success ? (
          <SvgIcon
            icon="tick_outline"
            width={className.includes('btn-lg') ? 27 : 16}
            height={className.includes('btn-lg') ? 27 : 16}
            color="white"
          />
        ) : (
          <>
            {loading ? (
              <div>
                <div
                  className={`${styles.button__loading} ${
                    bsStyle === 'hollow' ? styles.button__loadingHollow : ''
                  }`}
                ></div>{' '}
                {text}
              </div>
            ) : (
              text
            )}
          </>
        )}
      </Button>
    </>
  );
};

ButtonWithLoader.propTypes = {
  bsStyle: PropTypes.string,
  disabled: PropTypes.bool,
  href: PropTypes.string,
  loading: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  style: PropTypes.object,
  className: PropTypes.string,
  text: PropTypes.string.isRequired,
  success: PropTypes.bool,
  id: PropTypes.string,
};

export default ButtonWithLoader;
